import React from 'react';
import './LegalPages.css';
import './ContactAdditional.css';

const Contact: React.FC = () => {
  return (
    <div className="legal-page contact-page">
      <div className="legal-container">
        <div className="legal-header">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <h1>Contact Us</h1>
          <p className="legal-date">We'd love to hear from you!</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>📧 Get in Touch</h2>
            <p>
              Have questions, suggestions, feedback, or found a bug? We're here to help! 
              Feel free to reach out to us via email.
            </p>
          </section>

          <div className="contact-email-card">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <h2>Email Address</h2>
            <a href="mailto:psachin375@gmail.com" className="email-link">
              psachin375@gmail.com
            </a>
            <p className="email-note">Click to open your email client</p>
          </div>

          <div className="contact-info-grid">
            <div className="info-card">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              <h3>Response Time</h3>
              <p>We typically respond within 24-48 hours during business days</p>
            </div>

            <div className="info-card">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <h3>Location</h3>
              <p>Based in India</p>
            </div>

            <div className="info-card">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <h3>Privacy First</h3>
              <p>All text processing happens in your browser - 100% secure</p>
            </div>
          </div>

          <section className="legal-section">
            <h2>💡 Before You Contact Us</h2>
            <div className="info-box">
              <h3>Quick Tips for Better Support</h3>
              <ul>
                <li><strong>Be Specific:</strong> Describe your issue or question in detail</li>
                <li><strong>Include Details:</strong> Browser version, OS, and what you were trying to do</li>
                <li><strong>Screenshots Help:</strong> If reporting a bug, attach screenshots if possible</li>
                <li><strong>Check Browser Console:</strong> For technical issues, check browser console (F12) for errors</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>🐛 Common Topics</h2>
            <div className="topics-grid">
              <div className="topic-card">
                <span className="topic-icon">🐛</span>
                <h4>Bug Reports</h4>
                <p>Found something not working? Let us know!</p>
              </div>

              <div className="topic-card">
                <span className="topic-icon">✨</span>
                <h4>Feature Requests</h4>
                <p>Have an idea? We'd love to hear it!</p>
              </div>

              <div className="topic-card">
                <span className="topic-icon">💬</span>
                <h4>General Inquiries</h4>
                <p>Questions about how to use the tool</p>
              </div>

              <div className="topic-card">
                <span className="topic-icon">🤝</span>
                <h4>Partnerships</h4>
                <p>Interested in collaborating?</p>
              </div>

              <div className="topic-card">
                <span className="topic-icon">📝</span>
                <h4>Feedback</h4>
                <p>Share your thoughts and suggestions</p>
              </div>

              <div className="topic-card">
                <span className="topic-icon">❓</span>
                <h4>Other</h4>
                <p>Anything else on your mind</p>
              </div>
            </div>
          </section>

          <div className="legal-footer-note">
            <p>
              <strong>Note:</strong> We're a small team dedicated to providing the best text comparison 
              experience. Your patience and understanding is appreciated. All emails are read and responded 
              to personally!
            </p>
          </div>
        </div>

        <div className="legal-actions">
          <a href="/" className="btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;